import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from '../../../shared/services/message.service';
import { TabConstants } from '../../constants/tab.constants';
import { ManageUserTab } from '../../models/manage-user-tab-model';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'department-view-tabs',
    templateUrl: '../../templates/template1/views/admin/department-view-tabs.html',
    styleUrls: ['../../templates/template1/themes/default/css/admin.component.less'],
})
export class DepartmentViewTabsComponent implements OnInit {

    ManageDepartmentPermissions: any[] = [Permission.MANAGE_DEPARTMENT_VIEW,Permission.MANAGE_DEPARTMENT_EDIT];

    ManageUserPermissions: any[] = [Permission.MANAGE_DEPARTMENT_USERS_VIEW];

    @Input() departmentId: number;
    @Input() operatingCountryId: number;
    userTabs: ManageUserTab[] = [];
    activeTab: number;
    editDepartmentPermission: boolean;
    viewDepartmentPermission: boolean;
    viewUserPermission: boolean;
    emailConfigurationPermission: boolean;
    @ViewChild('departmentTabs') departmentTabs: TabsetComponent;
    enableEmailConfiguration: boolean = environment.enableEmailConfiguration;

    constructor(private messageService:MessageService,private _commonService: CommonService){   }
    ngOnInit() {
        this.activeTab = 1;
        this.subscribeUserTabContent(); 
        this.viewDepartmentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[0] + ']'),AccessLevel.Account);
        this.editDepartmentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[1] + ']'),AccessLevel.Account); 
        this.viewUserPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageUserPermissions[0] + ']'),AccessLevel.Department,this.departmentId);
        this.emailConfigurationPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_EMAIL_CONFIGURATION + ']'), AccessLevel.Customer_Service);;
    }
    selectTab(tab: number) {
        this.activeTab = tab;
    }

    /**
     * To add new tab immediately (to reflect in ui - used observable)
     */
    subscribeUserTabContent() {
        this.messageService.getManageUserTab().subscribe((data: ManageUserTab) => {

            if (data.departmentID === this.departmentId) {
                this.userTabs.forEach((tab: ManageUserTab) => { tab.active = false; });
                if (!data.closeUserManageTab) {
                    this.activeTab = 0;
                    if (this.userTabs.find((tab: ManageUserTab) => tab.userId === data.userId)) {
                        this.userTabs.forEach((tab: ManageUserTab) => { if (tab.userId === data.userId) { tab.active = true; } })
                    } else {
                        this.userTabs.push(data);
                        this.alignTabs();
                    }
                } else {
                    this.activeTab = 3;
                    const tab = this.userTabs.find((tab: ManageUserTab) => tab.userId === data.userId);
                    this.removeTab(tab);
                    this.alignTabs();
                }
            }
        });
    }
    removeTab(tab: ManageUserTab): void {
        if (this.userTabs.length > 0 && tab) {
            this.userTabs.splice(this.userTabs.indexOf(tab), 1);
            this.alignTabs();
            const tabIndex = this.departmentTabs.tabs.findIndex(item => item.id === TabConstants.DEPARTMENT_USER_SEARCH);
            this.departmentTabs.tabs[tabIndex].active = true;
            this.activeTab = 3;
        }
    }
    /**
     * @description To align tab content top
     * @date 2020-01-29
     * @memberof DepartmentViewTabsComponent
     */
    alignTabs(): void {
        setTimeout(() => {
            const element: any = document.querySelector('.active .cs-secondary-tabs.nav  > .nav-tabs');
            const tabContentElement: any = document.querySelector('.active .cs-secondary-tabs.nav > .tab-content');
            if (element && tabContentElement) {
                const tabsHeight = element.offsetHeight;
                tabContentElement.style.marginTop = (tabsHeight + 10) + 'px';
            }
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/admin/department-view-tabs.component.ts